import React from "react";
import ReactDOM from "react-dom";
import InTime from "./InTime";

function InTimeApp(): JSX.Element {
  return (
    <React.StrictMode>
      <React.Suspense>
        <InTime />
      </React.Suspense>
    </React.StrictMode>
  );
}

ReactDOM.render(<InTimeApp />, document.getElementById("InitivaInTime"));
